import { useEffect, useRef } from 'react'
import type { DataLayerAction } from '../TagContext.d'
import { useRouter } from 'next/router'
import { resolvePageData } from './resolvePageData'
import { useStoreConfig } from 'config'
import { parseUrlPathName } from '../utils/parseUrlPathName'

export const TrackUrlChange = ({
    dataLayerAction
}: {
    dataLayerAction: DataLayerAction
}): null => {
    const { events, asPath, isFallback } = useRouter()
    const trackedPagePath = useRef<string>()
    const {
        base: {
            url: { model }
        },
        seo: { customPages }
    } = useStoreConfig()
    const handleRouteChange = (input: string) => {
        const newPath = parseUrlPathName(input)
        if (newPath === trackedPagePath.current) {
            return
        }
        dataLayerAction({
            type: 'PAGE_VIEW',
            data: {
                ...resolvePageData(newPath, customPages, model),
                virtualPagePath: newPath
            }
        })
        trackedPagePath.current = newPath
    }
    useEffect(() => {
        events.on('routeChangeComplete', handleRouteChange)
        return () => {
            events.off('routeChangeComplete', handleRouteChange)
        }
    }, [])
    useEffect(() => {
        if (!isFallback && !trackedPagePath.current) {
            handleRouteChange(asPath)
        }
    }, [isFallback])

    // TODO: add checkout step tracking here, once checkout implementation is done

    return null
}
